import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ThemeSelectorService } from 'src/app/services/theme-selector.service';

@Component({
  selector: 'app-mmc-sign-iframe-modal',
  templateUrl: './mmc-sign-iframe-modal.component.html',
  styleUrls: ['./mmc-sign-iframe-modal.component.scss']
})
export class MmcSignIframeModalComponent implements OnInit {

  title: string;
  // Lo rellena el que abre el modal
  signingUrl: string;

  signingUrlSafe: SafeResourceUrl;
  isDarkTheme: boolean;

  constructor(
    public bsModalRef: BsModalRef,
    private sanitizer: DomSanitizer,
    private themeSelector: ThemeSelectorService
  ) {
    this.title = 'Sign agreement';
  }

  ngOnInit(): void {
    if (this.signingUrl) {
      this.signingUrlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.signingUrl);
    }
  }

  /**
   * Hides the modal
   */
  close(): void {
    this.bsModalRef.hide();
  }

  getTheme() {
    return this.themeSelector.isDarkTheme;
  }
}
